import { useEffect, useState } from 'react';

/**
 * 窄屏（移动端）判定 hook，带 resize 监听。
 * 默认断点 768px：< 768 视为移动端（列表卡片化、表单单列、模态全屏等）。
 * 桌面 Web 始终 ≥ 768 → 返回 false，行为不变；mobile-h5 原生壳里恒为 true。
 */
export function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
}
